import { CategoriesListComponentProps, CategoriesListComponentState, CategoriesListComponentHandler } from './categorieslistcomponent';
import * as React from 'react';
import { UIComponentHandler } from '../../../toolkit/uicomponent';
import { CategoriesListCSSStyle } from './categorieslistcss';
import { BaseContext } from '../../../../utils/basecontext';
import { ToneDto } from '../../../../core/dto/tonedto';
import { CRBTUIViewImpl } from '../crbt/crbtuiview';
import { Strings } from '../../../../utils/resources/strings';
import { GridTabViewModelImpl } from '../../../toolkit/gridtabs/gridtabviewmodel';
import { GridTabComponent } from '../../../toolkit/gridtabs/gridtabcomponent';
import { FeaturedToneRowOptionsImpl } from '../featuredcategory/viewmodel/featuredcategorylistviewmodel';
import { PopUpWrapperComponent } from '../../popup/popupwrappercomponent';
import { AlertType } from '../../../toolkit/alert/alerttype';
import { AlertComponent } from '../../../toolkit/alert/alertcomponent';
import { NoResultComponent } from '../../nametunes/noresult/noresultcomponent';
import { LoaderComponent } from '../../../toolkit/loader/loadercomponent';
import { LoaderWrapperComponent } from '../../popup/loaderwrappercomponent';
import { CategoriesTabViewModelImpl } from './categoriestabviewmodel';
import { AudioPlayerWithProgressImpl } from '../../../toolkit/player/playerwithprogress/playerwithprogressimpl';
import { CategoryToneListViewModelImpl } from './categorylistviewmodel';
import './categories-list-style.css';

export class CategoriesListViewImpl extends CRBTUIViewImpl
{
    private genericTabViewModel: GridTabViewModelImpl;
    private gridTabRef: GridTabComponent;
    private popUpComponent: PopUpWrapperComponent;
    private loaderWrapperComponent:LoaderWrapperComponent;
    private audioPlayerWithProgress: AudioPlayerWithProgressImpl;

    constructor(context: BaseContext, uiComponentHandler: UIComponentHandler)
    {
        super(context, uiComponentHandler);

        this.genericTabViewModel = new GridTabViewModelImpl();

        this.audioPlayerWithProgress = new AudioPlayerWithProgressImpl(context.getPlayerManager().getAudioPlayer());
    }

    bindHandlers()
    {
        this.onLoadMore = this.onLoadMore.bind(this);
        this.showLoader = this.showLoader.bind(this);
        this.dismissLoader = this.dismissLoader.bind(this);
        this.onTabSelected = this.onTabSelected.bind(this);
        this.onLoadMore = this.onLoadMore.bind(this);
    }

    getChildComponent(props: CategoriesListComponentProps, state: CategoriesListComponentState, cssStyle: CategoriesListCSSStyle): JSX.Element
    {
        return (
            <>
                {
        !state.isDataNotLoaded &&
            <div id="categories-list-div" style={cssStyle.getWrapperCSSStyle()}>
                <GridTabComponent isShowTabsTitle={false} id="categories-grid-tabs" onTabSelected={this.onTabSelected} ref={(item: any)=>{this.gridTabRef = item;}} initialTab={this.genericTabViewModel.getListOfTitles()[0]} genericTabViewModel={this.genericTabViewModel} context={props.context}/>
            </div>
    }
          {
        state.isDataNotLoaded &&
        <div style={{width:'100%',height:'100%',marginBottom:'0px'}}>
               <NoResultComponent   context={this.getContext()}/>
        </div>    
      }
            <PopUpWrapperComponent ref={(item: any) => this.popUpComponent = item} context={props.context}/>
      
            <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>
            </>
        );
    }
 
    onLoadMore(categoryId: number, startIndex: number, offset: number)
    {
        (this.getUIComponentHandler() as CategoriesListComponentHandler).loadMore(categoryId,
            this.genericTabViewModel.getSelectedTabTitle(), startIndex, offset);
    }

    closePopup()
    {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(false, <></>);
    }

    showPopup(msg:string,type:AlertType):void
    {   
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={this.closePopup} context={this.getUIProps().context}/>);   
    }
    showLoader()
    {
       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }
    getNavigationPath()
    {
        return [this.getUIProps().context.getResources().getString(Strings.home),
             this.getUIProps().context.getResources().getString(Strings.tune), (this.getUIProps() as CategoriesListComponentProps).categoryName];
    }

    getBannerImg()
    {
        return "categories.jpg";
    }

    removeAllTabs()
    {
        this.genericTabViewModel.removeAllTabs();
    }

    updateTabData(categoryId: number, context: BaseContext, title: string, tonedto: ToneDto[])
    {
        this.genericTabViewModel.addTab(new CategoriesTabViewModelImpl(categoryId, context, title, 
            new CategoryToneListViewModelImpl(context.getConfigurationSettings().getProperty("FETCH_LIMIT"),
            this.audioPlayerWithProgress, new FeaturedToneRowOptionsImpl(), context, "100px", title),
            this.onLoadMore));

        let tab = this.genericTabViewModel.getTab(title);
      
        tab !== undefined && (tab as CategoriesTabViewModelImpl).updateTabData(tonedto);
    }

    updateLoadMoreTabData(title: string, tonedto: ToneDto[])
    {
        let tab = this.genericTabViewModel.getTab(title);
      
        tab !== undefined && (tab as CategoriesTabViewModelImpl).updateLoadMoreTabData(tonedto);
    }

    updateTab()
    {
        this.gridTabRef.onTabSelected(this.genericTabViewModel.getListOfTitles()[0]);
    }

    getListOfTitles():string[]
    {
     return this.genericTabViewModel.getListOfTitles();
    }

    onTabSelected()
    {
        // let tab = this.genericTabViewModel.getTab(title);
        // console.log("----tab: " + tab + ", title:" + title);
      
        // tab !== undefined && (tab as CategoriesTabViewModelImpl).refreshData();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/categorieslist/categorieslistview.tsx